// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__pjPlE","resendInfoText":"OnGoingPaymentBox_resendInfoText__110wG"};